// useNodeContributionState.js

import { useState } from 'react';

export default function useNodeContributionState() {
  const [, setContributeOpen] = useState(false);
  const [contributeParent, setContributeParent] = useState(null);
  const [, setPreSelectedType] = useState(null);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraContentType, setCameraContentType] = useState(null);

  return {
    cameraOpen,
    cameraContentType,
    contributeParent,
    setContributeOpen,
    setContributeParent,
    setPreSelectedType,
    setCameraOpen,
    setCameraContentType,
  };
}
